import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { colorLightGray } from "../../../utils/palette";

const TimerModeCards = ({ selected, onChange, readOnly = false }) => {
  const { t } = useTranslation("common");

  return (
    <CardsRow>
      {/* Timer Mode card */}
      <CardWrapper selected={selected === 1} $readOnly={readOnly} onClick={readOnly ? undefined : () => onChange(1)}>
        <SelectionIndicator>
          {selected === 1 ? (
            <i
              className="fi fi-sr-check-circle"
              style={{ color: "#1e3a5f", fontSize: 18 }}
            />
          ) : (
            <RadioCircle />
          )}
        </SelectionIndicator>

        <PreviewBox>
          <PreviewRow>
            <span style={{ fontWeight: 500, fontSize: 13 }}>Oil Change</span>
            <span style={{ color: "#22c55e", fontWeight: 600, fontSize: 13 }}>
              ● 42m
            </span>
          </PreviewRow>
          <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
            <PauseBtn type="button">■ {t("pause")}</PauseBtn>
            <DoneBtn type="button">✓ {t("complete")}</DoneBtn>
          </div>
        </PreviewBox>

        <CardTitle>{t("timer_mode")}</CardTitle>
        <CardDesc>{t("timer_mode_desc")}</CardDesc>
        <BulletList>
          <BulletItem>{t("timer_mode_bullet_1")}</BulletItem>
          <BulletItem>{t("timer_mode_bullet_2")}</BulletItem>
          <BulletItem>{t("timer_mode_bullet_3")}</BulletItem>
        </BulletList>
      </CardWrapper>

      {/* Manual Entry card */}
      <CardWrapper selected={selected === 2} $readOnly={readOnly} onClick={readOnly ? undefined : () => onChange(2)}>
        <SelectionIndicator>
          {selected === 2 ? (
            <i
              className="fi fi-sr-check-circle"
              style={{ color: "#1e3a5f", fontSize: 18 }}
            />
          ) : (
            <RadioCircle />
          )}
        </SelectionIndicator>

        <PreviewBox>
          <PreviewRow>
            <span style={{ fontWeight: 500, fontSize: 13 }}>Oil Change</span>
            <span style={{ color: "#888", fontSize: 13 }}>Est. 1h</span>
          </PreviewRow>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              marginTop: 8,
            }}
          >
            <span style={{ fontSize: 12, color: "#555" }}>
              {t("time_spent")}:
            </span>
            <FakeSelect>2h ▾</FakeSelect>
            <FakeSelect>30m ▾</FakeSelect>
          </div>
        </PreviewBox>

        <CardTitle>{t("manual_entry")}</CardTitle>
        <CardDesc>{t("manual_entry_desc")}</CardDesc>
        <BulletList>
          <BulletItem>{t("manual_entry_bullet_1")}</BulletItem>
          <BulletItem>{t("manual_entry_bullet_2")}</BulletItem>
          <BulletItem>{t("manual_entry_bullet_3")}</BulletItem>
        </BulletList>
      </CardWrapper>
    </CardsRow>
  );
};

export default TimerModeCards;

const CardsRow = styled.div`
  display: flex;
  gap: 16px;
`;

const CardWrapper = styled.div`
  flex: 1;
  border: 2px solid ${({ selected }) => (selected ? "#1e3a5f" : "#e0e0e0")};
  border-radius: 12px;
  padding: 16px;
  cursor: ${({ $readOnly }) => ($readOnly ? "default" : "pointer")};
  position: relative;
  background: ${({ $readOnly }) => ($readOnly ? "#f9f9f9" : "white")};;
  transition: background 0.15s;
  &:hover {
    background: ${({ $readOnly }) => ($readOnly ? "#f9f9f9" : "#f5f5f5")};
  }
`;

const SelectionIndicator = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
`;

const RadioCircle = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #aaa;
  background: white;
`;

const PreviewBox = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 16px;
  background: #fafafa;
`;

const PreviewRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PauseBtn = styled.button`
  background: #fffbeb;
  color: #d97706;
  border: 1px solid ${colorLightGray};
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: default;
  pointer-events: none;
`;

const DoneBtn = styled.button`
  background: #1e3a5f;
  color: #fff;
  border: 1px solid ${colorLightGray};
  border: none;
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: default;
  pointer-events: none;
`;

const FakeSelect = styled.div`
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 12px;
  background: white;
`;

const CardTitle = styled.h5`
  font-weight: 700;
  margin-bottom: 6px;
  font-size: 15px;
`;

const CardDesc = styled.p`
  //color: #2eb26b;
  font-size: 13px;
  margin-bottom: 10px;
`;

const BulletList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const BulletItem = styled.li`
  font-size: 13px;
  &::before {
    color: #2eb26b;
    content: "✓  ";
    font-weight: 600;
  }
`;
